import { render, staticRenderFns } from "./reviewsDialog.vue?vue&type=template&id=3ede1ef7&scoped=true&"
import script from "./reviewsDialog.vue?vue&type=script&lang=js&"
export * from "./reviewsDialog.vue?vue&type=script&lang=js&"
import style0 from "./reviewsDialog.vue?vue&type=style&index=0&id=3ede1ef7&prod&lang=less&scoped=true&"
import style1 from "./reviewsDialog.vue?vue&type=style&index=1&id=3ede1ef7&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ede1ef7",
  null
  
)

export default component.exports